'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = function Root() {
  return (0, _preact.h)(
    _preact2.Provider,
    { store: _store2.default },
    (0, _preact.h)(
      _style2.default,
      null,
      (0, _preact.h)(_Container2.default, null)
    )
  );
};

exports.default = Root;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/root.js
// module id = 101
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38